import { Record as record } from 'immutable';

import { toPounds } from '../helpers/Currency';

import TicketType from './TicketType';
import { construct, resolve, fields } from '../helpers/LinkMapper';


const defaults = {
    differenceAmount: null,
    differenceInPercentage: null,
    numberOfTickets: null,
    priceOfTicketToCompare: null,
    ticketTypeRef: null
};


class FarePriceComparison extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(FarePriceComparison, json, {
            differenceAmount: fields.number,
            differenceInPercentage: fields.number,
            numberOfTickets: fields.number,
            priceOfTicketToCompare: fields.number,
            ticketTypeRef: resolve.as(TicketType)
        });
    }

    isEmpty () {
        return this.differenceInPercentage === null;
    }

    getComparedTicketName () {
        return this.ticketTypeRef.name;
    }

    getRoundedDifference () {
        return Math.floor(toPounds(this.differenceAmount));
    }
}

export default FarePriceComparison;



// WEBPACK FOOTER //
// ./src/records/FarePriceComparison.js